<nb-form-field>
  <input
    type="text"
    class="search-input"
    (keyup)="search($event)"
    nbInput
    fullWidth
    shape="round"
    placeholder="Search by workspace name, acronym, event name, or slug"
    status="primary"
  />
  <mat-icon matTooltip="Search your workspace events." nbPrefix>search</mat-icon>
</nb-form-field>
